// What a reader may change, page by page: the one switch behind Customise.
//
// Decision 0025: the Overview is presented, not personalised, so it offers no
// colours. It does let a reader hold a card to rearrange the grid, and choose
// light or dark under Customise (both back on 2026-10-14, on request): neither
// changes what the page claims, and both stay in that reader's browser. The accent is
// tripla's brand magenta and is no reader's to choose on any page. A lookup
// table rather than a flag in each component (house rule 5): the drawer, the
// header, the app shell and the Overview all read this one, so they cannot
// disagree.
export const CUSTOMISE = {
  '/': ['arrange', 'appearance'],
  '/progress': ['appearance', 'lines'],
  '/diagnostics': ['appearance', 'lines', 'series'],
}

/** What the Customise drawer holds. Arranging is done on the page itself. */
const DRAWER = ['appearance', 'lines', 'series']

/** Whether the page at `path` lets the reader change `what`. */
export const offers = (path, what) => (CUSTOMISE[path] ?? []).includes(what)

/** Whether the page at `path` has anything for the drawer, and so shows Customise. */
export const offersDrawer = (path) => (CUSTOMISE[path] ?? []).some((what) => DRAWER.includes(what))

/** Whether any page offers `what`. A stored accent applies only while one does. */
export const offeredAnywhere = (what) =>
  Object.values(CUSTOMISE).some((list) => list.includes(what))
